import { alpha } from '@mui/material';
export const REGISTRATION_FIELD_FILL_BG = alpha('#919EAB', 0.08);
